module.exports = __webpack_public_path__ + "static/media/je.5062c53b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/je.jpg
// module id = 729
// module chunks = 0